var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.859999 6.753L6.342 11.549C6.988 12.115 8 11.655 8 10.796V1.204C8.00016 1.01175 7.94491 0.823537 7.84086 0.661886C7.73681 0.500236 7.58836 0.372005 7.41331 0.292549C7.23825 0.213093 7.044 0.185781 6.85382 0.213882C6.66364 0.241984 6.48559 0.324309 6.341 0.450998L0.861 5.247C0.75359 5.34086 0.667504 5.45661 0.60852 5.58649C0.549536 5.71636 0.51902 5.85736 0.51902 6C0.51902 6.14264 0.549536 6.28363 0.60852 6.41351C0.667504 6.54338 0.75359 6.65914 0.861 6.753H0.859999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.0c503eb90f2ead8642c00709f4d1c57f.svg";
export { ForwardRef as ReactComponent };